module.exports = __webpack_public_path__ + "e97f8fbb56132d9095dc0b015ff14f9b.jpg";